/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom' ;
import { connect } from 'react-redux';
import { Row, Col, Button,FormGroup, Label, Table, Modal } from 'reactstrap';
import { setRoute, SaveAfterHoursDetailsforclient } from '../../../../../../action/manageTenantAction';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import classnames from 'classnames';
import Currencies from '../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import Conversions from '../../../../../../Resources/Conversions';
import { getAllResources } from '../../../../../../action/cultureAction';

let lstZonesRates = [];
let tempZoneRate = [];
class CreateTenant_AfterHours extends Component {
    componentDidMount(){

        tempZoneRate = [];
        lstZonesRates = [];
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
        if(this.props.ClientSideAfterHourState != undefined && this.props.ClientSideAfterHourState != null){
            let Data = this.props.ClientSideAfterHourState;
            this.refs.Cost_Per_Hour.value = Data.RatePerHour;
            this.refs.Zone_Cost.checked = Data.HasZoneRate;
            this.refs.SendTo_Requested_Employee.checked = Data.FacilitySetup.SendToRequestedEmployee;
            this.refs.SendTo_Additional_Recipient.checked = Data.FacilitySetup.SendToAdditionalRecipient;
            this.refs.Facility_Request_Email.value = (Data.FacilitySetup.ToEmailAddress).join(';');
            this.setState({AdditionalMail:!Data.FacilitySetup.SendToAdditionalRecipient, SelectedMinReqHrs:Data.MinmumAfterHour,SelectedRoundup:Data.RounderHours});
            if(Data.HasZoneRate){
                this.setState({ IsZoneRate: false });
            }
        }
        if(this.props.UserPreference_response !== undefined && this.props.UserPreference_response !== null){
            this.setState({UserPreferenceFormat:this.props.UserPreference_response})
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            routeModules: { },
            redirect:  false,
            modal: false,
            IsZoneRate: true,
            IsModalClose:false,
            redirectBack:false,
            AdditionalMail:true,
            UserPreferenceFormat:[],
            IsZoneRateErr: false,
            SelectedMinReqHrs: "Select",
            SelectedRoundup: "Select",
            Isdisable: true,
        }
        this.goNext = this.goNext.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onCostChanged = this.onCostChanged.bind(this);
        this.onSaveRates = this.onSaveRates.bind(this);
        this.goBack = this.goBack.bind(this);
        this.toggleEmail = this.toggleEmail.bind(this);
    }

    handleChange = (event) => {
        this.setState({
            SelectedMinReqHrs: event.target.value
        });
        if(event.target.value === "Select"){
            this.setState({Isdisable : true});
            this.setState({
                SelectedRoundup: "Select"
            });
        }
        
        else{
            this.setState({Isdisable : false});
        }
       
    }

    handleChange1 = (event) => {
        this.setState({
            SelectedRoundup: event.target.value
        });
    }

    toggleEmail(){
        this.setState({AdditionalMail: !this.state.AdditionalMail});
    }

    goBack (){
        this.setState({redirectBack: true});
    }
    onSaveRates(Rows){
        
        let IsValid = true;
        tempZoneRate = [];
        lstZonesRates = [];

        for(let i=0; i < Rows.length; i++){
            var id=Rows[i].props.children[0].props.children[0].ref; 
            let ZoneId = Rows[i].props.children[0].props.children[0].props.id;
            let ZoneName = Rows[i].props.children[2].props.children;
            let ZoneRate = Conversions.getInvariantNumberForAH(this.state.UserPreferenceFormat,this.refs[id].value);
            

            if(ZoneRate != null && ZoneRate != ""&& ZoneRate !== "NaN"){
                let NumberFormat = /^[0-9\b.]+$/;
                if(!NumberFormat.test(ZoneRate)){
                    IsValid = false;
                }
                else{
                    tempZoneRate.push(ZoneRate);
                }
            }else{
                if(ZoneRate !== 0)
                    IsValid = false;
            }
            lstZonesRates.push({zoneId:ZoneId,zoneName:ZoneName,ZoneRate:ZoneRate});
        }
        if(IsValid){
            this.setState({modal: !this.state.modal});
        }else{
            lstZonesRates = [];
            this.setState({modal: this.state.modal, IsZoneRateErr : true});
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    onCostChanged(){
        if(this.refs.Zone_Cost.checked){
            this.setState({ IsZoneRate: false });
        }else{
            this.setState({ IsZoneRate: true });
        }
    }

    goNext() {
        let IsValid = true;
        this.setState({IsModalClose: true});
        
        let Rate_Per_Hour = Conversions.getInvariantNumberForAH(this.state.UserPreferenceFormat,this.refs.Cost_Per_Hour.value);
        let Minimum_AfterHr = this.refs.Minimum_Request_Input.options.selectedIndex; 
        let Minimum_Hr = this.refs.Minimum_Request_Input.options[Minimum_AfterHr].value;
        let Rounder_Hour = this.refs.Roundup_Nearest_Input.options.selectedIndex; 
        let Round_Hr = this.refs.Roundup_Nearest_Input.options[Rounder_Hour].value;
        let Has_ZoneRate = this.refs.Zone_Cost.checked;
        

        if(Rate_Per_Hour != null && Rate_Per_Hour != "" && Rate_Per_Hour !== "NaN"){
            let NumberFormat = /^[0-9\b.]+$/;
            if(!NumberFormat.test(Rate_Per_Hour)){
                IsValid = false;
                this.setState({IsModalClose: true});
            }
        }else{
            if(Rate_Per_Hour !== 0){
                IsValid = false;
                this.setState({IsModalClose: true});
            }
        }
        if(this.refs.SendTo_Additional_Recipient.checked){
            if(this.refs.Facility_Request_Email.value == null || this.refs.Facility_Request_Email.value == ""){
                IsValid = false;
                this.setState({IsModalClose: true});
            }
            let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var EmailIds = this.refs.Facility_Request_Email.value; 
            var Ids = EmailIds.split(';');
            for(let i=0; i<Ids.length; i++){
                var MailId = Ids[i].trim();
                if(MailId !== "" && !MailId.match(Email)){
                    IsValid = false;
                    this.setState({IsModalClose: true});
                }
            }
        }

        if(Has_ZoneRate){
            if(lstZonesRates.length === 0){
                if (this.props.getResponse.length !== undefined && this.props.getResponse.length) { 
                    var Rows = this.props.getResponse;
                    for(let i=0; i < Rows.length; i++){
                        lstZonesRates.push({zoneId:Rows[i].zoneId,zoneName:Rows[i].zoneName,ZoneRate:"50.00"});
                    }
                }
            }
        }
        
        if(IsValid){
            let lstEmail = [];
            if(this.refs.SendTo_Additional_Recipient.checked && this.refs.Facility_Request_Email.value != null){
                lstEmail = (this.refs.Facility_Request_Email.value).split(';');
            }
            let Facility_Setup = {"SendToRequestedEmployee":this.refs.SendTo_Requested_Employee.checked,"SendToAdditionalRecipient":this.refs.SendTo_Additional_Recipient.checked,"ToEmailAddress":lstEmail};
            var data = {
                "HasAfterHoursOption": true,
                "RatePerHour"  : Rate_Per_Hour,
                "MinmumAfterHour"  : Minimum_Hr,
                "RounderHours"  : Round_Hr,
                "HasZoneRate"  : Has_ZoneRate,
                "ZoneRates" : lstZonesRates,
                "FacilitySetup" : Facility_Setup
            }

            this.setState({redirect: true});
            this.props.SaveAfterHoursDetailsforclient(data);
        }
    }
    
    render(getResponse,manageTenantsParams,ClientSideAfterHourState,getLabels,UserPreference_response) {
        let CurrencySymb = null, errormsg1;
        if(this.props.manageTenantsParams !== undefined && this.props.manageTenantsParams !== null){
            CurrencySymb=  Currencies.CurrenciesList(this.props.manageTenantsParams.CurrencyId);
        }
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        if(this.state.redirect){
            return <Redirect to={"/managetenant/TenantNormalHours"} />
        }
        if(this.state.redirectBack){
            return <Redirect to={"/managetenant/BuildingSubgroups"} />
        }
        if(this.state.IsModalClose){
            var errormsg = <p  className="error_msg">
                            <img src={ErrorGif} alt="Trane Logo" /> 
                            {label['CheckTemperatureAdjustment.Text']}
                            </p> 
        }
        if(this.state.IsZoneRateErr){
            errormsg1 = <p  className="error_msg">
                            <img src={ErrorGif} alt="Trane Logo" /> 
                            {label['CheckTemperatureAdjustment.Text']}
                            </p> 
        }
        let Available_Zones, modal_form_1;
        if (this.props.getResponse != undefined) {
            if (this.props.getResponse.length) { 
                Available_Zones = this.props.getResponse.map((el, index) => (
                            <tr>
                                <td style={{"font-family":"Arial"}}><input type="text" id={el.zoneId} ref={'ref_' + el.zoneId} defaultValue={(tempZoneRate[index] != undefined && tempZoneRate[index] != null)?Conversions.formatNumber(PreferedDateFormat,tempZoneRate[index]):Conversions.formatNumber(PreferedDateFormat,'50.00')}/>&nbsp;{CurrencySymb}</td>
                                <td>{el.buildingName}</td>
                                <td>{el.zoneName}</td>
                                <td>{el.members}</td>
                            </tr>
                ));               
            }
            else{
                Available_Zones = <tr> <td colSpan="4">No Records Found</td> </tr>
            } 
        }
        modal_form_1 =  <div className="table_container">
                        <legend className="form_sub_title">{label['CreateTenant.EditCost.Text']}</legend>
                        {errormsg1}
                        <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th>{label['SubGroups.Columns.CostPerHr.Text'] !== undefined ? label['SubGroups.Columns.CostPerHr.Text'] : "Cost per Hour"}</th>
                                <th>{label['SubGroups.Columns.SiteName.Text'] !== undefined ? label['SubGroups.Columns.SiteName.Text'] : "Building"}</th>
                                <th>{label['SubGroups.Columns.Zones.Text'] !== undefined ? label['SubGroups.Columns.Zones.Text'] : "Zones"}</th>
                                <th>{label['SubGroups.Columns.Members.Text'] !== undefined ? label['SubGroups.Columns.Members.Text'] : "Members"}</th>                                
                            </tr>
                            {Available_Zones}
                        </tbody>
                        </Table>
                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 10 }}>
                                <Button className="btn-gray btn-md" id="createtenant_AF_apply" onClick={this.toggle}>{label['TemperatureAdjustment.Cancel.Text'] !== undefined ? label['TemperatureAdjustment.Cancel.Text'] : "Cancel"} </Button>
                                <Button className="btn-success btn-md" id="createtenant_AF_cancel" onClick={() => this.onSaveRates(Available_Zones)}>{label['ManageHolidays.Apply.Text'] !== undefined ? label['ManageHolidays.Apply.Text'] : "Apply"}</Button>
                            </Col>
                        </FormGroup>
                        </div>
            
        return (
            <div className="EnsembleCreateTenant">   
              {errormsg}
              {/* Info Icon to the right */}
             <Row>
                 <Col sm={{size: 1, offset: 11 }} className="text-right" >
                 <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                 </Col>
                 </Row>
                 {/* Title */}
                 <h4 className="form_title">{label['CreateTenant.RequestsSetup.Text']}</h4>

                 {/* Page Sub-Title */}
                 
               <div className="Customised_form_div">
               <legend className="form_sub_title">{label['CreateTenant.BillingSetup.Text']}</legend>

               <div className="form_group ">
               <Label className="Custom_label_small_width">{label['CreateTenant.AfterHoursHourlyRate.Text']}</Label>
               </div>

               <div className="form_group">
               <table>
                <tr>
                    <td>
                    <input type="radio" ref="Same_Cost" id="createtenant_samecost" name="rdCost"  value="0"  defaultChecked="true" onChange={this.onCostChanged} />{label['CreateTenant.DefaultRate.Text'] !== undefined ? label['CreateTenant.DefaultRate.Text'] : "Same cost for all zones"}
                    </td>
                    <td style={{"font-family":"Arial","padding-left":"94px"}}> 
                    <input className="custom_input default-input input_small_width" id="createtenant_samecost_txt" type="text" ref="Cost_Per_Hour" defaultValue={Conversions.formatNumber(PreferedDateFormat,'50.00')} />&nbsp;{CurrencySymb}
                    </td>
                </tr>
               </table> 
               </div>

                <div className="form_group" style={{"margin-bottom":"16px"}}>
                <input type="radio" ref="Zone_Cost" name="rdCost" id="createtenant_rdcost"  value="1" onChange={this.onCostChanged} />{label['CreateTenant.GroupRate.Text'] !== undefined ? label['CreateTenant.GroupRate.Text'] : "Different costs for different zones"} 
                <Button className="btn-black btn-md" style={{"margin-left":"34px"}} id="createtenant_edit_cost" ref="btnEditCost" disabled={this.state.IsZoneRate} onClick={this.toggle}>{label['CreateTenant.btnEditCost.Text'] !== undefined ? label['CreateTenant.btnEditCost.Text'] : "Edit Costs"}</Button>
                </div>

               <div className="form_group">
               <Label className="Custom_label_small_width">{label['CreateTenant.MinimumAfterHourschange.Text']}</Label>
               <select ref='Minimum_Request_Input' id="createtenant_minimum_req" onChange={this.handleChange} value={this.state.SelectedMinReqHrs} className="custom_input default-input select_small_width">Hour
                    <option>Select</option>
                    <option value="0.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'0.5')}</option>
                    <option value="1.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.0')}</option>
                    <option value="1.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.5')}</option>
                    <option value="2.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.0')}</option>
                    <option value="2.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.5')}</option>
                    <option value="3.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'3.0')}</option>
               </select>
               <span className="Custom_label_small_width" style={{"padding-left":"15px"}}>{label['CreateTenant.Hour.Text']}</span>
               </div>

               <div className="form_group">
               <Label className="Custom_label_small_width">{label['CreateTenant.BilledItem.Text']}</Label>
               <select ref='Roundup_Nearest_Input' id="createtenant_roundup" onChange={this.handleChange1} disabled={this.state.Isdisable} value={this.state.SelectedRoundup} className="custom_input default-input select_small_width">{label['CreateTenant.Hour.Text']}
                    <option>Select</option>
                    <option value="0.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'0.5')}</option>
                    <option value="1.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.0')}</option>
                    <option value="1.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.5')}</option>
                    <option value="2.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.0')}</option>
                    <option value="2.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.5')}</option>
                    <option value="3.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'3.0')}</option>
               </select>
               <span className="Custom_label_small_width" style={{"padding-left":"15px"}}>{label['CreateTenant.Hour.Text']}</span>
               </div>

            
             <div className="clear">&nbsp;</div>
             <legend className="form_sub_title">{label['TenantFacility.EditModeHeading.Text']}</legend>
                    <div className="form_group form_group_textare">
                        <FormGroup check>
                            <Label check>
                                <input type="checkbox" defaultChecked="true"  ref="SendTo_Requested_Employee" />{' '}
                                {label['TenantFacility.Option1.Text']}
                                      </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <input type="checkbox" onChange={this.toggleEmail} ref="SendTo_Additional_Recipient" />{' '}
                                {label['TenantFacility.Option3.Text']}
                                     </Label>
                        </FormGroup>
                    </div>
                    <div className="form_group form_group_textarea">
               {/* <input ref="Facility_Request_Email" disabled={this.state.AdditionalMail} className="custom_input default-input" type="textarea" /> */}
                <textarea ref="Facility_Request_Email" id="createtenant_additional_mail" rows="5" style={{"width": "500px"}} disabled={this.state.AdditionalMail} className="custom_input default-input" />
               </div>
               <div className="form_group form_group_textarea">
               <Label >{label['CreateTenant.lblEmailBoxUAText.Text']}
               </Label>
               </div>
               
               {/* Actions Buttons */}

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" id="createtenant_AH_back" onClick={this.goBack}> {label['Wizards.BackButton.Text']}   </Button>
                            <Button className="btn-success btn-md" id="createtenant_AH_next" onClick={this.goNext}>{label['Wizards.NextButton.Text']} </Button>
                        </Col>
                    </FormGroup>
               </div>
               <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    {modal_form_1}
              </Modal>   
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
        manageTenantsParams: state.manageTenant.ClientSideComapnyData,
        getResponse: state.manageTenant.ClientSideZonesData,
        ClientSideAfterHourState: state.manageTenant.ClientSideAfterHoursData,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setRoute: (params) => dispatch(setRoute(params)),
        SaveAfterHoursDetailsforclient: (data) => dispatch(SaveAfterHoursDetailsforclient(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTenant_AfterHours)